import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon-logo.png'
import _imports_1 from '@img/icon-googleplay.png'
import _imports_2 from '@img/icon-ios.png'


const _withScopeId = n => (_pushScopeId("data-v-506040fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "CopyrightFooter container"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "download-type" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line-2" }, "Google Play")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line-2" }, "App Store")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
type IGgotoUrlMap = {
  google: string;
  apple: string;
};
type IProtocolUrlMap = {
  terms: string;
  privacy: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const gotoUrlMap: IGgotoUrlMap = {
  google: "https://play.google.com/store/apps/details?id=com.dianyun.chikii",
  apple: "https://apps.apple.com/us/app/chikii-ssh-server-toolbox/id1609781496",
};
const protocolUrlMap: IProtocolUrlMap = {
  terms: "http://www.chikiigame.com/m/userAgreements/index.html",
  privacy: "http://www.chikiigame.com/m/privacy/index.html",
};

// 跳转协议页
const gotoProtocolPage = (type: keyof IProtocolUrlMap) => {
  if (!protocolUrlMap[type]) return;
  window.open(protocolUrlMap[type], "_blank");
};
const gotoPage = (type: keyof IGgotoUrlMap) => {
  console.log("gotoUrlMap[type]", gotoUrlMap[type]);
  window.open(gotoUrlMap[type], "_blank");
};
const isShowFooter = computed(() => {
  if (
    ["DownLoad", "VIP", "GoodsDetail", "GameShare"].indexOf(route.name) !== -1
  ) {
    return false;
  } else {
    return true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(isShowFooter))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h3", null, " Copyright © 2020-" + _toDisplayString(new Date().getFullYear()) + " CHIKII GLOBAL Pte. Ltd. ", 1),
          _createElementVNode("h3", null, [
            _createTextVNode(" All Rights Reserved. "),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoProtocolPage('terms')))
            }, "User Agreement"),
            _createTextVNode(" and "),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoProtocolPage('privacy')))
            }, "Privacy Policy")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "google active-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (gotoPage('google')))
            }, _hoisted_8),
            _createElementVNode("div", {
              class: "apple active-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (gotoPage('apple')))
            }, _hoisted_11)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})